import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿Cómo recibo el Kit?',
    a: 'Inmediatamente después del pago recibís un email con el link de descarga. Todo en PDF listo para usar.'
  }, {
    q: '¿Sirve para escuelas técnicas y universidades?',
    a: 'Sí, el contenido está estructurado para adaptarse tanto a nivel secundario técnico como a nivel superior y universitario.'
  }, {
    q: '¿Es editable?',
    a: 'El material viene en formato PDF de alta calidad, listo para imprimir o compartir digitalmente con tus alumnos.'
  }, {
    q: '¿Los 4 bonos están incluidos?',
    a: 'Sí, tanto el Kit Básico como el Pack Pro incluyen los 4 bonos de regalo.'
  }, {
    q: '¿Puedo comprar básico y actualizar?',
    a: 'Sí, podés hacerlo, pero recomendamos adquirir el Sistema Pro desde el inicio por el valor agregado de las clases listas.'
  }, {
    q: '¿Funciona para clases presenciales y virtuales?',
    a: 'Totalmente. El material se adapta a ambos formatos de enseñanza sin problemas.'
  }, {
    q: '¿Incluye legislación actualizada?',
    a: 'Sí, todo el contenido de legislación y contratos está basado en la normativa vigente argentina.'
  }, {
    q: '¿Está organizado por nivel?',
    a: 'Sí, los temas tienen una progresión lógica, desde conceptos básicos hasta análisis de casos complejos.'
  }, {
    q: '¿Tiene garantía?',
    a: 'Sí, contás con 7 días de garantía de satisfacción total.'
  }, {
    q: '¿Qué diferencia tiene con material de internet?',
    a: 'No son textos sueltos o leyes sin explicación. Es un sistema pedagógico completo, pensado específicamente para enseñar.'
  }];
  return <section className="bg-[#E8F5E9] py-3 md:py-4 px-3 border-b border-gray-200" data-id="element-35">
      <div className="max-w-2xl mx-auto" data-id="element-36">
        <h2 className="text-xl md:text-2xl font-black text-[#1F3D2B] text-center mb-3 uppercase tracking-tight" data-id="element-37">
          Preguntas Frecuentes
        </h2>
        <div className="space-y-1" data-id="element-38">
          {faqs.map((faq, i) => <div key={i} className="bg-[#F5F6F7] border border-gray-200 rounded-lg overflow-hidden" data-id="element-39">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full flex items-center justify-between p-2 text-left hover:bg-gray-100 transition-colors" data-id="element-40">
                <span className="font-black text-[#1F3D2B] text-xs md:text-sm pr-3" data-id="element-41">
                  {faq.q}
                </span>
                <motion.div animate={{
              rotate: openIndex === i ? 180 : 0
            }} data-id="element-42">
                  <ChevronDown className="w-4 h-4 text-[#D4A843] flex-shrink-0" strokeWidth={3} data-id="element-43" />
                </motion.div>
              </button>
              <AnimatePresence data-id="element-44">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} className="overflow-hidden" data-id="element-45">
                    <div className="px-2 pb-2 text-gray-700 font-bold text-[10px] md:text-xs border-t border-gray-200 pt-1.5 bg-white" data-id="element-46">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}